export class BusinessBookingRecipientDtoDelegate {
  static isTypeEmployee(type) {
    return type === 'employee';
  }

  static isTypeGuest(type) {
    return type === 'guest';
  }
}
